import { render, staticRenderFns } from "./CreatePasswordForm.vue?vue&type=template&id=77f6ff3a&scoped=true&"
import script from "./CreatePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./CreatePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreatePasswordForm.vue?vue&type=style&index=0&id=77f6ff3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f6ff3a",
  null
  
)

export default component.exports